import config from "../../config";

export default function matchSupportedLocale(lang) {
  if (typeof lang !== "string") {
    return undefined;
  }

  const normalized = lang.toLowerCase().split(/[-_]/)[0];

  if (config.supportedLocales.includes(normalized)) {
    return normalized;
  }

  return undefined;
}
